import React from "react";
import "./TomNookApp.css";
import tomNookImage from "./assets/tomnook.png";

const TomNookApp = ({ message }) => {
  const defaultMessage =
    "Hi, I'm Tom Nook! Nothing to see here, you can explore more on the applications on the left.";
  return (
    <div className="tomnook-app">
      <div className="tomnook-content">
        <h1>{message || defaultMessage}</h1>
      </div>
      <img src={tomNookImage} alt="Tom Nook" className="tomnook-image" />
    </div>
  );
};

export default TomNookApp;
